module.exports = __webpack_public_path__ + "img/ETH.3b269003.svg";